<svg-icon class="w-44 h-48" [src]="'plant'"></svg-icon>

<p class="font-secondary italic text-9xl text-navy-80">
  {{ 'core.invalidLink.invalidText' | translate }}
</p>

<p class="flex flex-col items-center text-navy-90" [innerHTML]="'core.invalidLink.message' | translate"></p>
